module.exports = __webpack_public_path__ + "img/walking-athletes-long.94f14d61.jpg";